import moment from 'moment'

import Educational from '../../views/educational/Main.vue'
import LearningTrails from '../../views/educational/LearningTrails.vue'
import Advisors from '../../views/Advisors.vue'
import Tasks from '../../views/Tasks.vue'
import Products from '../../views/Products.vue'
import Appointments from '../../views/Appointments.vue'
import SignUp from '../../views/SignUp.vue'
import PaymentsCalendar from '../../views/PaymentsCalendar.vue'

import { mainStore } from '../../store'

import formatDate from '../../common/formatDate'
import request from '../../common/request'
import variables from '../../variables'
import verify from './verify'

export default {
    async resetStore(to, from) {
        const store = mainStore()

        const reset = ![
            'login',
            'account-recovery',
            'subscribe',
            'updateSubscription',
            'changeSubscriptionPlan',
            'changeSubscriptionPayment',
        ].includes(to.name)
        const notTransactionPage = to.name !== 'transactions' && to.name !== 'payment_transactions'
        const family = store.isOttoFamily

        let extraQueries = {}
        if (store.plannerWithFamily) extraQueries.user = store.mainUserId

        if (!formatDate.compareDates(store._date.inicio, store._date_selected.inicio)) {
            try {
                store.DISABLED()
                store.WAITING(true)

                if (to.name === 'transactions') {
                    await request.fetch([
                        { collection: 'balances', queryParams: { ...store._date_selected, family, ...extraQueries } },
                        {
                            collection: 'balancesChart',
                            queryParams: { ...store._date_selected, family, ...extraQueries },
                        },
                    ])
                } else if (to.name === 'payment_transactions') {
                    const paymentId = getPaymentId(to)

                    await request.fetch([
                        { collection: 'balances', queryParams: { ...store._date_selected, paymentId } },
                        { collection: 'balancesChart', queryParams: { ...store._date_selected, paymentId } },
                    ])
                } else if (reset) {
                    await request.changeMonth(store._date, undefined, false, family, extraQueries.user)
                    store.setSelectedDate(store._date)
                }
            } catch (e) {
                console.error(e)
            }

            store.DISABLED()
        } else {
            if (family && notTransactionPage && reset) {
                await request.fetch([
                    { collection: 'balances', queryParams: { ...store._date_selected, family, ...extraQueries } },
                    { collection: 'balancesChart', queryParams: { ...store._date_selected, family, ...extraQueries } },
                ])
            }
        }
    },

    setDate() {
        const store = mainStore()
        let date = new Date()

        // salvando o mês atual
        let dataAtual = {
            inicio: formatDate.convertDate(date.getFullYear(), date.getMonth(), 1),
            fim: formatDate.convertDate(date.getFullYear(), date.getMonth() + 1, 0),
        }

        store.setAtualDate(dataAtual)
    },

    getPaymentId(to) {
        const store = mainStore()

        return to.name === 'payment_transactions' && store.findById('payments', to.params.payment) !== 'credit'
            ? to.params.payment
            : undefined
    },

    verifyUsage() {
        let lastReload = localStorage.getItem('last_reload')

        const reload = () => {
            localStorage.setItem('last_reload', new Date().toISOString())
            location.reload()
        }

        if (!lastReload) reload()
        else if (moment().diff(moment(lastReload), 'days')) reload()
    },

    getLimitedRoutes() {
        let [containerRoutes, defaultRoutes] = [[], []]

        if (!variables.hideScreens.hideScreenEducational) {
            containerRoutes.push(
                ...[
                    {
                        path: '/educacional',
                        name: 'educational',
                        component: Educational,
                        beforeEnter: verify.ifAuthenticated,
                    },
                    {
                        path: '/educacional/trilhas-de-aprendizado/:id',
                        name: 'learningTrails',
                        component: LearningTrails,
                        beforeEnter: verify.ifAuthenticated,
                    },
                ],
            )
        }

        if (!variables.hideScreens.hideScreenSpecialists) {
            containerRoutes.push({
                path: '/especialistas',
                name: 'especialistas',
                component: Advisors,
                beforeEnter: verify.ifAuthenticated,
            })
        }

        if (!variables.hideScreens.hideScreenTasks) {
            containerRoutes.push({
                path: '/tarefas',
                name: 'tarefas',
                component: Tasks,
                beforeEnter: verify.ifAuthenticated,
            })
        }

        if (!variables.hideScreens.hideScreenProducts) {
            containerRoutes.push({
                path: '/produtos',
                name: 'produtos',
                component: Products,
                beforeEnter: verify.ifAuthenticated,
            })
        }

        if (!variables.hideScreens.hideScreenAppointments) {
            containerRoutes.push({
                path: '/agendamentos',
                name: 'Agendamentos',
                component: Appointments,
                beforeEnter: verify.ifAuthenticated,
            })
        }

        if (!variables.hideScreens.hideScreenCalendar) {
            containerRoutes.push({
                path: '/calendario',
                name: 'calendar',
                component: PaymentsCalendar,
                beforeEnter: verify.ifAuthenticated,
            })
        }

        if (!variables.hideScreens.hideScreenSignUp) {
            defaultRoutes.push({
                path: '/cadastro',
                name: 'cadastro',
                component: SignUp,
                beforeEnter: verify.ifNotAuthenticated,
            })
        }

        return { containerRoutes, defaultRoutes }
    },
}
